import { render, staticRenderFns } from "./create-floating-menu.vue?vue&type=template&id=abe22e30&"
import script from "./create-floating-menu.vue?vue&type=script&lang=js&"
export * from "./create-floating-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports